<svg id="typewriterSvg">
  <ng-content></ng-content>
</svg>
